module.exports = __webpack_public_path__ + "img/spider_chart_example.f0d0f6b0.png";